const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];

export interface VenueInterface {
    id: number | null;
    documentId: string | null;
    venueKey: string | null;
    name: string | null;
    cover: string | null;
    location: string | null;
    age: string | null;
    address: string | null;
    city: string | null;
    createdAt: string | null;
    updatedAt: string | null;
    publishedAt: string | null;
    state: string | null;
    visibility: string | null;
    insta: string | null;
    daysToVisit: string | null;
    whatToExpect: string | null;
    market: string | null;
    website: string | null;
    zip: string | number | null;
}

export class Venue implements VenueInterface {
    id: number | null;
    documentId: string | null;
    venueKey: string | null;
    name: string | null;
    cover: string | null;
    location: string | null;
    age: string | null;
    address: string | null;
    city: string | null;
    createdAt: string | null;
    updatedAt: string | null;
    publishedAt: string | null;
    state: string | null;
    visibility: string | null;
    insta: string | null;
    daysToVisit: string | null;
    whatToExpect: string | null;
    market: string | null;
    website: string | null;
    zip: string | number | null;

    constructor(params: Partial<VenueInterface> = {}) {
        this.id = params.id ?? null;
        this.documentId = params.documentId ?? null;
        this.venueKey = params.venueKey ?? null;
        this.name = params.name ?? null;
        this.cover = params.cover ?? null;
        this.location = params.location ?? null;
        this.age = params.age ?? null;
        this.address = params.address ?? null;
        this.city = params.city ?? null;
        this.createdAt = params.createdAt ?? null;
        this.updatedAt = params.updatedAt ?? null;
        this.publishedAt = params.publishedAt ?? null;
        this.state = params.state ?? null;
        this.visibility = params.visibility ?? null;
        this.insta = params.insta ?? null;
        this.daysToVisit = params.daysToVisit ?? null;
        this.whatToExpect = params.whatToExpect ?? null;
        this.market = params.market ?? null;
        this.website = params.website ?? null;
        this.zip = params.zip ?? null;
    }
}

export interface VenueListInterface {
    venues : VenueInterface[];
}

export class VenueList implements VenueListInterface {
    venues: Venue[];

    constructor(venues: Venue[]) {
        this.venues = venues;
    }
}

export const loadVenues = async (market?: string): Promise<Venue[]> => {
    let filter = "";
    if (market !== undefined) {
        filter = `&filters[market][$eq]=${market}`;
    }
    // Add sort by name ascending
    const sort = "&sort=name:asc";
    const pageSize = 100;
    const venues: Venue[] = [];

    try {
        let page = 1;

        while (true) {
            const response = await fetch(
                `${BACKEND_HOST}/venues?pagination[pageSize]=${pageSize}&pagination[page]=${page}${filter}${sort}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json"
                    }
                }
            );

            const data = await response.json();

            if (!Array.isArray(data.data) || data.data.length === 0) {
                break;
            }

            venues.push(
                ...data.data.map((v: any) => new Venue({
                    id: v.id ?? null,
                    documentId: v.documentId ?? null,
                    venueKey: v.venueKey ?? null,
                    name: v.name ?? null,
                    cover: v.cover ?? null,
                    location: v.location ?? null,
                    age: v.age ?? null,
                    address: v.address ?? null,
                    city: v.city ?? null,
                    createdAt: v.createdAt ?? null,
                    updatedAt: v.updatedAt ?? null,
                    publishedAt: v.publishedAt ?? null,
                    state: v.state ?? null,
                    visibility: v.visibility ?? null,
                    insta: v.insta ?? null,
                    daysToVisit: v.daysToVisit ?? null,
                    whatToExpect: v.whatToExpect ?? null,
                    market: v.market ?? null,
                    website: v.website ?? null,
                    zip: v.zip ?? null
                }))
            );

            const pagination = data.meta?.pagination;
            if (pagination?.page != null && pagination?.pageCount != null && pagination.page >= pagination.pageCount) {
                break;
            }

            if (data.data.length < pageSize) {
                break;
            }

            page += 1;
        }

        return venues;
    } catch (e: any) {
        console.error("Error loading venues:", e.message);
        return [];
    }
};